export const subscribeForm = () => {
  $('.subscribe-mail-name .ft-form').validate({
    submitHandler: function (form) {
      $('.subscribe-mail-name.subscribe-block').addClass('active');

      setTimeout(function () {
        $('.subscribe-mail-name.subscribe-block form').hide();
        $('.subscribe-mail-name.subscribe-block')
          .html(
            `
          <div class="subscribe__text">
            Subscription Confirmed!
            </div>
        `
          )
          .removeClass('active');
      }, 1000);
    },
    success: () => {},
    errorPlacement: function (error, element) {
      const _element = $(element);
      if (_element.hasClass('error')) {
        _element.closest('div[class^="form-holder"]').addClass('has-error').removeClass('accept');
        _element.addClass('error');
      } else {
        _element.closest('div[class^="form-holder"]').removeClass('has-error').addClass('accept');
        _element.removeClass('error');
      }
    },
    rules: {
      email: {
        required: true,
        email: true,
      },
      name: {
        required: true,
      },
    },
  });
  $('.subscribe-mail .ft-form').validate({
    submitHandler: function (form) {
      $('.subscribe-mail.subscribe-block').addClass('active');

      setTimeout(function () {
        $('.subscribe-mail.subscribe-block form').hide();
        $('.subscribe-mail.subscribe-block')
          .html(
            `
          <div class="subscribe__text">
            Subscription Confirmed!
            </div>
        `
          )
          .removeClass('active');
      }, 1000);
    },
    success: () => {},
    errorPlacement: function (error, element) {
      const _element = $(element);
      if (_element.hasClass('error')) {
        _element.closest('div[class^="form-holder"]').addClass('has-error').removeClass('accept');
        _element.addClass('error');
      } else {
        _element.closest('div[class^="form-holder"]').removeClass('has-error').addClass('accept');
        _element.removeClass('error');
      }
    },
    rules: {
      email: {
        required: true,
        email: true,
      },
    },
  });
  $('.subscribe-phone .ft-form').validate({
    submitHandler: function (form) {
      $('.subscribe-phone.subscribe-block').addClass('active');

      setTimeout(function () {
        $('.subscribe-phone.subscribe-block form').hide();
        $('.subscribe-phone.subscribe-block')
          .html(
            `
          <div class="subscribe__text">
            Subscription Confirmed!
          </div>
        `
          )
          .removeClass('active');
      }, 1000);
    },
    success: () => {},
    errorPlacement: function (error, element) {
      const _element = $(element);
      if (_element.hasClass('error')) {
        _element.closest('div[class^="form-holder"]').addClass('has-error').removeClass('accept');
        _element.addClass('error');
      } else {
        _element.closest('div[class^="form-holder"]').removeClass('has-error').addClass('accept');
        _element.removeClass('error');
      }
    },
    rules: {
      phone: {
        required: true,
        digits: true,
        maxlength: 20,
      },
    },
  });

  $('.white-10-cont .right-side form').validate({
    submitHandler: function (form) {
      $('.white-10-cont .right-side').addClass('active');

      setTimeout(function () {
        $('.white-10-cont .right-side form').hide();
        $('.white-10-cont .right-side')
          .html(
            `
          <div class="subscribe__text">
            Subscription Confirmed!
            </div>
        `
          )
          .removeClass('active');
      }, 1000);
    },
    success: () => {},
    errorPlacement: function (error, element) {
      const _element = $(element);
      if (_element.hasClass('error')) {
        _element.closest('div[class^="form-holder"]').addClass('has-error').removeClass('accept');
        _element.addClass('error');
      } else {
        _element.closest('div[class^="form-holder"]').removeClass('has-error').addClass('accept');
        _element.removeClass('error');
      }
    },
    rules: {
      'f-first': {
        required: true,
        minlength: 2,
      },
      'f-last': {
        required: true,
        minlength: 2,
      },
      'f-phone': {
        required: true,
        phoneUS: false,
        digits: true,
        minlength: 7,
      },
      'f-company': {
        required: true,
      },
      'f-describes': {
        required: true,
      },
      'f-country': {
        required: true,
      },
      'f-address': {
        required: true,
        minlength: 5,
      },
      'f-website': {
        required: true,
      },
      'f-message': {
        maxlength: 500,
      },
    },

    messages: {
      'f-first': 'Enter your first name',
      'f-last': 'Enter your last name',
      'f-phone': 'Enter a valid phone number',
      'f-company': 'Enter company name',
      'f-describes': 'Select one option',
      'f-country': 'Enter your country',
      'f-address': 'Enter street address',
      'f-website': 'Enter a valid website URL',
    },
  });
  $('.subscribe-phone .ft-form__input[name="phone"]')
    .attr('maxlength', 20)
    .on('keypress', function (e) {
      if (e.which < 48 || e.which > 57) {
        e.preventDefault();
      }
    })
    .on('input', function () {
      if (this.value.length > 20) {
        this.value = this.value.slice(0, 20);
      }
    });

  $('.contact-form form').validate({
    submitHandler: function (form) {
      if (
        $('#contactCheck1').is(':checked') &&
        $('#contactCheck2').is(':checked') &&
        $('#contactCheck3').is(':checked') &&
        $('#contactCheck4').is(':checked')
      ) {
        $('.contact-form__result').html(`
              Thank you for your message. It has been sent.
          `);
      }
    },
    success: () => {},
    errorPlacement: function (error, element) {
      const _element = $(element);
      if (_element.hasClass('error')) {
        _element.closest('div[class^="form-holder"]').addClass('has-error').removeClass('accept');
        _element.addClass('error');
      } else {
        _element.closest('div[class^="form-holder"]').removeClass('has-error').addClass('accept');
        _element.removeClass('error');
      }
    },
    rules: {
      contactFirstName: {
        required: true,
      },
      contactLastName: {
        required: true,
      },
      contactPhone: {
        required: true,
      },
      contactEmail: {
        required: true,
        email: true,
      },
      contactSelect: {
        required: true,
      },
      contactMessage: {
        required: true,
      },
      contactCheck1: {
        required: true,
      },
      contactCheck2: {
        required: true,
      },
      contactCheck3: {
        required: true,
      },
      contactCheck4: {
        required: true,
      },
    },
  });

  $('.contact-form form input[name="phone"]')
    .attr('maxlength', 20)
    .on('keypress', function (e) {
      if (e.which < 48 || e.which > 57) {
        e.preventDefault();
      }
    })
    .on('input', function () {
      if (this.value.length > 20) {
        this.value = this.value.slice(0, 20);
      }
    });
};
